import IconInformation from 'approot/shared/icons/icon-information';
import TooltipWrapper from './tooltip-wrapper';
import { TooltipInfoStyled } from './tooltip-info.style';

type Props = {
  hoverText?: string;
  hoverHeading?: string;
  multiline?: boolean;
  isPurple?: boolean;
};

const TooltipInfo = ({
  hoverText,
  hoverHeading,
  multiline = false,
  isPurple,
}: Props) => {
  return (
    <TooltipInfoStyled data-selector="tool-tip" $isPurple={isPurple}>
      <TooltipWrapper
        multiline={multiline}
        hoverHeading={hoverHeading}
        hoverText={hoverText}
      >
        <span tabIndex={0}>
          <IconInformation />
        </span>
      </TooltipWrapper>
    </TooltipInfoStyled>
  );
};

export default TooltipInfo;
